export default function SectionHeading({ title, desc, className = "", ...rest }) {
  return (
    <div className={`peb-section ${className}`} {...rest}>
      {title != null && <p className="peb-section__title">{title}</p>}
      {desc != null && <p className="peb-section__desc">{desc}</p>}
    </div>
  );
}
